import { lazy } from 'react'

const MarketingSupport = lazy(
  () => import('./pages/marketing-support/marketing-support')
)

export { MarketingSupport }
